import { Flex } from 'antd'
import React, { ReactNode } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'

type Props = {
  children: ReactNode
  organizationMemberAgent: OrganizationMemberFromContext
}

export const Background: React.FC<Props> = ({
  children,
  organizationMemberAgent,
}) => {
  const pictureUrl =
    'https://sdmntprnorthcentralus.oaiusercontent.com/files/00000000-8ca4-622f-afda-39e86b4c9071/raw?se=2025-04-17T21%3A02%3A16Z&sp=r&sv=2024-08-04&sr=b&scid=d77f4df0-7ed5-5df1-84e2-6111675b787a&skoid=06d77cea-897f-49c6-9d78-20f6510f72af&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2025-04-17T05%3A20%3A42Z&ske=2025-04-18T05%3A20%3A42Z&sks=b&skv=2024-08-04&sig=oyHGBaVdXw5AAoyLHW5aphsdot%2BF4i/ftslgPZWufPQ%3D'

  const background = 'white'
  // const background = '#05c92e'

  return (
    <Flex className="w-full" vertical style={{ background: 'white' }}>
      {children}
    </Flex>
  )

  return (
    <>
      <Flex vertical className="w-full ">
        <Flex
          className="w-full"
          style={{
            height: '110px',
            overflow: 'hidden',
            position: 'relative',
            background: background,
          }}
        >
          {/* <img
            style={{ objectFit: 'cover', objectPosition: 'top' }}
            width="100%"
            src={pictureUrl}
          /> */}

          <Flex
            className="w-full h-full"
            align="end"
            style={{
              position: 'absolute',
              background: `linear-gradient(to top, white, transparent)`,
              bottom: 0,
            }}
          >
            {children}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
